<template>
  <el-dialog
    :visible.sync="visible"
    width="420px"
    :show-close="false"
    :close-on-click-modal="false"
    @closed="onClosed"
    custom-class="auth-modal"
  >
    <div class="auth-card">
      <div class="auth-head">
        <img class="auth-logo" src="@/assets/logo-blue.svg" alt="" />
        <h3 class="auth-title">{{ titleMap[mode] }}</h3>
        <button class="auth-close" @click="visible = false">×</button>
      </div>

      <div class="auth-tabs" v-if="mode === 'login'">
        <span :class="{ active: type === 'account' }" @click="type = 'account'">账号登录</span>
        <span :class="{ active: type === 'sms' }" @click="type = 'sms'">短信登录</span>
      </div>

      <el-form :model="form" :rules="rules" ref="form" class="auth-form">
        <el-form-item prop="username">
          <div class="field-label">手机号</div>
          <el-input v-model="form.username" placeholder="请输入手机号" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item prop="password" v-if="mode === 'login' && type === 'account'">
          <div class="field-label">密码</div>
          <el-input v-model="form.password" placeholder="请输入密码" show-password></el-input>
        </el-form-item>

        <template v-if="mode !== 'login'">
          <el-form-item prop="password">
            <div class="field-label">密码</div>
            <el-input v-model="form.password" placeholder="请输入密码" show-password></el-input>
          </el-form-item>
          <el-form-item prop="confirmPwd">
            <div class="field-label">确认密码</div>
            <el-input v-model="form.confirmPwd" placeholder="请再次输入密码" show-password></el-input>
          </el-form-item>
        </template>

        <el-form-item prop="code" v-if="mode !== 'login' || type === 'sms'">
          <div class="field-label">验证码</div>
          <div class="code-row">
            <el-input v-model="form.code" placeholder="请输入验证码" @keyup.enter.native="submit('form')"></el-input>
            <button
              :class="['code-btn', !countshow && 'is-disabled']"
              :disabled="!countshow"
              @click="getCode"
            >{{ countshow ? '获取验证码' : `${count}s` }}</button>
          </div>
        </el-form-item>

        <div class="auth-extras" v-if="mode === 'login'">
          <el-checkbox v-model="checked">
            <span class="text-muted">记住登录</span>
          </el-checkbox>
          <a class="link" @click="setMode('forget')">忘记密码？</a>
        </div>
      </el-form>

      <div class="auth-foot">
        <button class="g-btn g-btn-primary g-btn-block g-btn-lg" @click="submit('form')">
          {{ btnMap[mode] }}
        </button>
        <div class="auth-tip">
          <el-checkbox v-model="agreeCheck">
            <span class="text-muted">已阅读并接受</span>
            <a class="link" @click="openAgree">《用户协议与隐私政策》</a>
          </el-checkbox>
        </div>
        <div class="auth-help">
          <span class="text-muted">咨询热线：</span>
          <strong>蒋经理 19179363419</strong>
        </div>
        <div class="auth-switch" v-if="mode === 'login'">
          还没有账号？<a class="link" @click="setMode('register')">立即注册</a>
        </div>
        <div class="auth-switch" v-else>
          已有账号？<a class="link" @click="setMode('login')">返回登录</a>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { login, register, forgetPsd, getPublicKey } from '@/lib/api/login'
import { getNoCode } from '@/lib/api/project'
import { encrypt } from '@/lib/utils/jsencrypt'

export default {
  name: 'AuthModal',
  data () {
    const validatePass = (rule, value, cb) => {
      if (!value) return cb(new Error('请输入密码'))
      if (this.form.confirmPwd !== '') this.$refs.form.validateField('confirmPwd')
      cb()
    }
    const validatePass2 = (rule, value, cb) => {
      if (!value) return cb(new Error('请确认密码'))
      if (value !== this.form.password) return cb(new Error('两次输入不一致'))
      cb()
    }
    return {
      mode: 'login',
      type: 'account',
      checked: false,
      agreeCheck: false,
      visible: false,
      timer: null,
      count: 60,
      countshow: true,
      form: { username: '', password: '', code: '', confirmPwd: '' },
      rules: {
        username: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确' }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { pattern: /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9A-Za-z]{8,30}/, message: '至少8位且包含大小写字母和数字' }
        ],
        confirmPwd: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ],
        code: [{ required: true, message: '请填写验证码', trigger: 'blur' }]
      },
      titleMap: { login: '欢迎回来', register: '创建账号', forget: '找回密码' },
      btnMap: { login: '登 录', register: '注 册', forget: '重置密码' }
    }
  },
  watch: {
    visible (v) {
      if (!v) {
        this.countshow = true
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
  methods: {
    open (mode = 'login') {
      this.mode = mode
      this.type = 'account'
      this.form = { username: '', password: '', code: '', confirmPwd: '' }
      this.agreeCheck = false
      this.checked = false
      this.visible = true
    },
    setMode (m) {
      this.mode = m
      this.form = { username: '', password: '', code: '', confirmPwd: '' }
      this.countshow = true
      clearInterval(this.timer)
      this.timer = null
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    onClosed () {
      this.mode = 'login'
      this.form = { username: '', password: '', code: '', confirmPwd: '' }
      this.countshow = true
      clearInterval(this.timer)
      this.timer = null
      this.agreeCheck = false
    },
    openAgree () {
      const routeData = this.$router.resolve({ name: 'agree' })
      window.open(routeData.href, '_blank')
    },
    async getCode () {
      if (this.countshow) {
        if (this.form.username === '') {
          return this.$message.warning('请先填写手机号')
        }
        this.count = 60
        this.countshow = false
        this.timer = setInterval(() => {
          if (this.count > 0) {
            this.count--
          } else {
            this.countshow = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
        try {
          await getNoCode({ phone: this.form.username })
          this.$message.success('验证码已发送')
        } catch (e) { /* ignore */ }
      }
    },
    requireAgree () {
      if (!this.agreeCheck) {
        this.$message.warning('请阅读并同意《用户协议与隐私政策》')
        return false
      }
      return true
    },
    submit (formName) {
      if (!this.requireAgree()) return
      this.$refs[formName].validate(async (valid) => {
        if (!valid) return
        if (this.mode === 'login') {
          try {
            const { publicKey } = await getPublicKey()
            const payload = { ...this.form, password: encrypt(this.form.password, publicKey) }
            if (this.type === 'sms') delete payload.password
            const res = await login(payload)
            if (res.code === 200) {
              this.$message.success('登录成功！')
              this.$store.commit('login', res.data.token)
              this.$store.commit('isCheck', res.data.deptId)
              localStorage.setItem('nickName', res.data.user.userName)
              localStorage.setItem('userId', res.data.user.userId)
              this.visible = false
              this.$emit('login-success', res.data)
              if (res.data.deptId === 'null') {
                this.$alert('请前往账号认证', '提示', {
                  confirmButtonText: '去认证',
                  callback: () => this.$router.push('/attestation')
                })
              }
            } else {
              this.$message.error(res.msg)
            }
          } catch (e) {
            this.$message.error('登录失败，请稍后再试')
          }
        } else if (this.mode === 'register') {
          const res = await register({ ...this.form }).catch(() => null)
          if (res && res.code === 200) {
            this.$message.success('注册成功，请登录')
            this.setMode('login')
          } else {
            this.$message.error(res ? res.msg : '注册失败')
          }
        } else if (this.mode === 'forget') {
          const { publicKey } = await getPublicKey()
          const res = await forgetPsd({
            ...this.form,
            password: encrypt(this.form.password, publicKey)
          }).catch(() => null)
          if (res && res.code === 200) {
            this.$message.success('密码已重置，请使用新密码登录')
            this.setMode('login')
          } else {
            this.$message.error(res ? res.msg : '重置失败')
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.auth-card {
  position: relative;
}

.auth-head {
  text-align: center;
  position: relative;
  margin-bottom: 20px;

  .auth-logo { height: 32px; margin-bottom: 8px; }
  .auth-title { font-size: 20px; font-weight: 600; color: @text-strong; margin: 0; }
  .auth-close {
    position: absolute;
    top: -8px; right: -8px;
    width: 28px; height: 28px;
    background: transparent;
    border: none;
    font-size: 22px;
    color: @text-muted;
    cursor: pointer;
    border-radius: 50%;

    &:hover { background: @bg-soft; color: @text-strong; }
  }
}

.auth-tabs {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 20px;
  border-bottom: 1px solid @border-light;

  span {
    padding: 8px 0;
    font-size: 14px;
    color: @text-muted;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: color @duration-fast @ease-out;
    &.active {
      color: @primary;
      border-bottom-color: @primary;
      font-weight: 600;
    }
  }
}

.field-label {
  font-size: 12px;
  color: @text-muted;
  margin-bottom: 4px;
}

.code-row {
  display: flex;
  gap: 8px;
  align-items: center;

  .code-btn {
    flex-shrink: 0;
    width: 110px;
    height: 36px;
    border-radius: @radius-sm;
    border: 1px solid @primary;
    color: @primary;
    background: @primary-soft;
    cursor: pointer;
    font-size: 13px;
    transition: all @duration-fast @ease-out;

    &.is-disabled,
    &:disabled {
      color: @text-disabled;
      background: @bg-soft;
      border-color: @border-base;
      cursor: not-allowed;
    }
  }
}

.auth-extras {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.auth-foot {
  margin-top: 16px;

  .auth-tip {
    margin-top: 12px;
    font-size: 12px;
  }

  .auth-help {
    margin-top: 12px;
    text-align: center;
    font-size: 12px;
    color: @text-muted;

    strong { color: @primary; margin-left: 4px; }
  }

  .auth-switch {
    text-align: center;
    margin-top: 16px;
    font-size: 13px;
    color: @text-muted;

    .link { color: @primary; cursor: pointer; font-weight: 500; }
  }
}

.link { color: @primary; cursor: pointer; font-size: 12px; }
.text-muted { color: @text-muted; font-size: 12px; }
</style>
